export const actionTypes = {
  GET_REPORT_MENU_START: 'GET_REPORT_MENU_START',
  GET_REPORT_MENU_SUCCESS: 'GET_REPORT_MENU_SUCCESS',
  GET_REPORT_MENU_FINISH: 'GET_REPORT_MENU_FINISH',

  ADD_REPORT_MENU_START: 'ADD_REPORT_MENU_START',
  ADD_REPORT_MENU_SUCCESS: 'ADD_REPORT_MENU_SUCCESS',
  ADD_REPORT_MENU_FINISH: 'ADD_REPORT_MENU_FINISH',
  RESET_REPORT_MENU: 'RESET_REPORT_MENU',

  UPDATE_REPORT_MENU_START: 'UPDATE_REPORT_MENU_START',
  UPDATE_REPORT_MENU_SUCCESS: 'UPDATE_REPORT_MENU_SUCCESS',
  UPDATE_REPORT_MENU_FINISH: 'UPDATE_REPORT_MENU_FINISH',

  DELETE_REPORT_MENU_START: 'DELETE_REPORT_MENU_START',
  DELETE_REPORT_MENU_SUCCESS: 'DELETE_REPORT_MENU_SUCCESS',
  DELETE_REPORT_MENU_FINISH: 'DELETE_REPORT_MENU_FINISH',

  SINGLE_ENABLE_REPORT_MENU_REQUEST: 'SINGLE_ENABLE_REPORT_MENU_REQUEST',
  SINGLE_ENABLE_REPORT_MENU_SUCCESS: 'SINGLE_ENABLE_REPORT_MENU_SUCCESS',
  SINGLE_ENABLE_REPORT_MENU_FINISH: 'SINGLE_ENABLE_REPORT_MENU_FINISH',

  SINGLE_DISABLE_REPORT_MENU_REQUEST: 'SINGLE_DISABLE_REPORT_MENU_REQUEST',
  SINGLE_DISABLE_REPORT_MENU_SUCCESS: 'SINGLE_DISABLE_REPORT_MENU_SUCCESS',
  SINGLE_DISABLE_REPORT_MENU_FINISH: 'SINGLE_DISABLE_REPORT_MENU_FINISH',

  ENABLE_REPORT_MENU_REQUEST: 'ENABLE_REPORT_MENU_REQUEST',
  ENABLE_REPORT_MENU_SUCCESS: 'ENABLE_REPORT_MENU_SUCCESS',
  ENABLE_REPORT_MENU_FINISH: 'ENABLE_REPORT_MENU_FINISH',

  DISABLE_REPORT_MENU_REQUEST: 'DISABLE_REPORT_MENU_REQUEST',
  DISABLE_REPORT_MENU_SUCCESS: 'DISABLE_REPORT_MENU_SUCCESS',
  DISABLE_REPORT_MENU_FINISH: 'DISABLE_REPORT_MENU_FINISH',
}
